import { isIgnoredTaskComparisonKey, normalizeTaskComparisonValue } from "./task-comparison-normalization.mjs"

export function comparePayloadWithOriginal(payload, original) {
    for (const [key, payloadValue] of Object.entries(payload)) {
        if (shouldIgnoreKey(key)) {
            continue
        }

        const originalValue = normalizeValue(original[key])
        const normalizedPayloadValue = normalizeValue(payloadValue)

        if (!(key in original)) {
            return false
        }

        if (isEmpty(normalizedPayloadValue) && isEmpty(originalValue)) {
            continue
        }

        if (typeof normalizedPayloadValue === "object" && normalizedPayloadValue !== null) {
            if (!comparePayloadWithOriginal(normalizedPayloadValue, originalValue)) {
                return false
            }
        } else {
            if (normalizedPayloadValue !== originalValue) {
                return false
            }
        }
    }

    return true

    function isEmpty(value) {
        return value === null || value === "" || value === undefined
    }
}

function shouldIgnoreKey(key) {
    return isIgnoredTaskComparisonKey(key) || key.startsWith("_") || key.startsWith("$")
}

function normalizeValue(value) {
    return normalizeTaskComparisonValue(value)
}
